import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component<Button>({
  data() {
    return {
      inProgress: false,
    };
  }
})
export default class Button extends Vue {
  @Prop()
  icon!: any;

  // State
  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  awaitable!: boolean;

  // Variants
  @Prop({ type: Boolean, default: false })
  outline!: boolean;

  @Prop({ type: Boolean, default: false })
  text!: boolean;

  @Prop({ type: Boolean, default: false })
  cta!: boolean;

  @Prop({ type: Boolean, default: false })
  dotted!: boolean;

  @Prop({ type: Boolean, default: false })
  compressed!: boolean;

  @Prop({ type: String, default: null })
  badge!: boolean;

  get hasIcon(): boolean {
    return !!this.icon;
  }

  get hasSlot(): boolean {
    return !!this.$slots.default;
  }

  isDisabled() {
    return this.disabled || this.$data.inProgress;
  }

  async onClick(e: Event): Promise<void> {
    if (this.$data.inProgress) return;
    if (this.awaitable && this.$listeners.click) {
      this.$data.inProgress = true;
      await this.$nextTick();
      // @ts-ignore
      await this.$listeners.click(e);
    }
    else {
      this.$emit('click', e);
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 30));
      this.$data.inProgress = true;
    }
    await new Promise((resolve) => setTimeout(resolve, 200));
    this.$data.inProgress = false;
  }

  clickAnimation(e: Event | any): void {
    const target = e && e.target;
    const ripple = target && target.querySelector('.ripple');

    if (ripple) {
      if (ripple && ripple.classList.contains('ripple-animate')) {
        ripple.classList.remove('ripple-animate');
      }

      if (!ripple.offsetHeight && !ripple.offsetWidth && target) {
        const longestDimension =
          target.offsetWidth > target.offsetHeight
            ? target.offsetWidth
            : target.offsetHeight;
        ripple.style.height = `${longestDimension / 16}rem`;
        ripple.style.width = `${longestDimension /16 }rem`;
      }

      ripple.style.top = `${e.layerY / 16}rem`;
      ripple.style.left = `${e.layerX / 16}rem`;
      ripple.classList.add('ripple-animate');
    }
  }
}
